import { graphql } from '../graphql';

export const myProjectsQuery = graphql(`
  query MyProjects {
    projects {
      id
      name
      srid
      organizationId
      storageUsedBytes
    }
  }
`);

export const getProjectQuery = graphql(`
  query GetProject($id: ID!) {
    project(id: $id) {
      id
      name
      description
      srid
      organizationId
      initialPosition
      initialAngle
    }
  }
`);

export const getSharedProjectQuery = graphql(`
  query GetSharedProject {
    sharedProject {
      id
      name
      srid
      organizationId
      initialPosition
      initialAngle
      organization {
        name
        slug
        logo {
          url
        }
      }
    }
  }
`);

export const createProjectMutation = graphql(`
  mutation CreateProject($input: CreateProjectInput!) {
    createProject(input: $input) {
      id
      name
      srid
    }
  }
`);

export const getProjectJobsQuery = graphql(`
  query GetProjectJobs($projectId: ID!) {
    jobs(projectId: $projectId) {
      id
      type
      status
      inputJson
      outputJson
      logs
      errorLogs
      startedAt
      completedAt
      estimatedCompletion
      leaseUntil
      attempts
      isLeaf
      batchId
      parentItemId
      createdAt
      updatedAt
    }
  }
`);

export const getProjectJobsByBatchQuery = graphql(`
  query GetProjectJobsByBatch($batchId: ID!) {
    jobs: jobsByBatch(batchId: $batchId) {
      id
      type
      status
      inputJson
      outputJson
      logs
      errorLogs
      startedAt
      completedAt
      estimatedCompletion
      leaseUntil
      attempts
      isLeaf
      batchId
      parentItemId
      createdAt
      updatedAt
    }
  }
`);

export const getProjectLinksQuery = graphql(`
  query GetProjectLinks($projectId: ID!) {
    projectLinks(projectId: $projectId) {
      id
      projectId
      name
      token
      expiresAt
      createdAt
      createdById
      status
      createdBy {
        id
        name
        email
        avatar {
          url
        }
      }
    }
  }
`);

export const getAllProjectLinksQuery = graphql(`
  query GetAllProjectLinks {
    allProjectLinks {
      id
      projectId
      project {
        id
        name
      }
      name
      token
      expiresAt
      createdAt
      createdById
      status
      createdBy {
        id
        name
        email
        avatar {
          url
        }
      }
    }
  }
`);
